// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1Xay5","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1wRst"};